module.exports = __webpack_public_path__ + "358ddf2053e3c0cf876491e4b5e36d2d.png";